<div class="header">
  <div class="row flex-between-end">
    <div class="align-self-center d-flex justify-content-between">
      <h6 class="mb-0">{{ title() }}</h6>
      <div class="toggle-button" (click)="show.set(!show())">
        {{ show() ? "-" : "+" }}
      </div>
    </div>
  </div>
</div>
@if (show()) {
  <div
    class="multi-select-content"
    [class.multi-select-content--loading]="loading()"
  >
    @if (loading()) {
      <div class="multi-select-loading" aria-busy="true">
        <span class="spinner-border spinner-border-sm" role="status"></span>
      </div>
    }
    <hr />
    <div id="multi-select{{ index() }}" class="multi-select-options">
      @for (item of items(); track item.id; let i = $index) {
        <div class="form-check">
          <input
            class="form-check-input"
            id="multi-select-{{ index() }}-{{ i }}"
            type="checkbox"
            name="'index'"
            (change)="onSelectionChange(item)"
            [checked]="isSelected(item)"
          />
          <label
            class="form-check-label"
            for="multi-select-{{ index() }}-{{ i }}"
            >{{ item.text }}</label
          >
        </div>
      }
    </div>
  </div>
}
